/**
 * The single canonical reCAPTCHA Enterprise site key for this site.
 *
 * "B2B localsearch 2026" in Google Cloud project sonic-totem-480201-r6,
 * registered for the business.localsearch.com.au domain (apex + www variants).
 *
 * Site keys are public by design (they ship in the page), so this lives in
 * source rather than in an env var — the previous `VITE_RECAPTCHA_SITE_KEY`
 * held a stale reCAPTCHA Classic key that no Enterprise project owned, which
 * meant every server-side assessment for those forms was doomed. Keeping one
 * value in one place stops that from happening again.
 *
 * The server verifies against `RECAPTCHA_SITE_KEY`; if that secret ever drifts
 * from this value, `submitEnquiry` logs a site-key-mismatch warning.
 */
export const RECAPTCHA_SITE_KEY = "6LcQCs4sAAAAAIN_zubY6ByP1hwugUJaDCnbYz1-";
